export default "__VITE_ASSET__CWOj40KK__"